import { render, staticRenderFns } from "./ComplementaryTreatmentsCard.vue?vue&type=template&id=1e3ffe9c&scoped=true"
import script from "./ComplementaryTreatmentsCard.vue?vue&type=script&lang=js"
export * from "./ComplementaryTreatmentsCard.vue?vue&type=script&lang=js"
import style0 from "./ComplementaryTreatmentsCard.vue?vue&type=style&index=0&id=1e3ffe9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ffe9c",
  null
  
)

export default component.exports